import block from './block.json';

export const cardAddressThemeAttributes = {
	backgroundColor: '@tokens.variants.default.cardBackgroundColor',
	border: {
		color: '@tokens.variants.default.cardBorderColor',
		width: {
			top: [1, 1],
			right: [1, 1],
			bottom: [1, 1],
			left: [1, 1],
		},
		radius: {
			topLeft: [0, 0],
			topRight: [0, 0],
			bottomRight: [0, 0],
			bottomLeft: [0, 0],
		},
	},
	minWidth: '328px',
	maxWidth: '528px',
	padding: {
		top: [10, 20],
		right: [10, 20],
		bottom: [10, 20],
		left: [10, 20],
	},
	image: {
		width: [142, 209],
	},
	title: {
		color: '@tokens.variants.default.cardTitleColor',
		typography: '@tokens.typographies.heading-5',
		textAlignment: 'left',
	},
	text: {
		color: '@tokens.variants.default.cardContentColor',
		typography: '@tokens.typographies.introduction',
		textAlignment: 'left',
	},
	states: {
		hover: {}, // adds hover state
	},
};

export const CardAddressThemeControls: ThemeControlsType = {
	// What's displayed
	title: block.title,

	// Unique string/id of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: cardAddressThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
